import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useFormikContext } from "formik";
import FormFieldWrapper from "components/FormFieldWrapper";
import FormAutocompleteCategory from "components/FormAutoCompleteCategory";
import axios from "axios";
import { fetchCategories } from "store/category/actions";
import { baseUrl, headers } from "../../../lib/api/constants";

const CategoryAutocomplete = ({ label, field, requiredMessage, required, dependsOnValue, attributeToChange, habilitateAttributeValues, ...props }) => {
  const dispatch = useDispatch();
  const form = useFormikContext();
  const { values } = form || {};
  const [searchCategory, setSearchCategory] = useState("");

  const [listCategories, setListCategories] = useState([]);
  const [previousClientId, setPreviousClientId] = useState(null);

  const clientId = values?.clientId;


  async function getCategories(clientIdToFilter) {
    try {
      const endpoint = clientIdToFilter 
        ? `${baseUrl}/categories?clientId=${clientIdToFilter}&limit=1000`
        : `${baseUrl}/categories?limit=1000`;
      
      const r = await axios
        .get(endpoint, {
          method: "GET",
          headers,
        })
        .catch((err) => console.log(err));

      if (r?.data) {
        const categories = r.data.data?.rows || r.data.data || r.data.category || [];
        setListCategories(categories);
      }
    } catch (err) {
      console.error("Error fetching categories:", err);
    }
  }

  useEffect(() => {
    if (clientId && clientId !== "" && clientId !== "-1") {
      getCategories(clientId);
      if (previousClientId !== null && previousClientId !== clientId) {
        form.setFieldValue(field.name, "");
      }
      setPreviousClientId(clientId);
    } else {
      setListCategories([]);
      if (field.value) {
        form.setFieldValue(field.name, "");
      }
      setPreviousClientId(null);
    }
  }, [clientId]);

  useEffect(() => {
    function searchCategoryAction() {
      if (searchCategory) {
        dispatch(fetchCategories({ search: searchCategory || "", clientId }));
      }
    }

    const timeout = setTimeout(searchCategoryAction, 300);

    return () => {
      clearTimeout(timeout);
    };
  }, [dispatch, searchCategory, clientId]);

  return (
    <FormFieldWrapper
      name={field.name}
      label={label}
      errorMessage={requiredMessage}
      required={required}
    >
      <FormAutocompleteCategory
        required={required}
        requiredMessage={requiredMessage}
        onSearchExternal={setSearchCategory}
        options={listCategories}
        label={label}
        field={field}
        optionLabelSelector={"name"}
        optionValueSelector={"_id"}
        dependsOnValue={dependsOnValue}
        attributeToChange={attributeToChange}
        habilitateAttributeValues={habilitateAttributeValues}
        style={{ width: "100%" }}
        {...props}
      />
    </FormFieldWrapper>
  );
};

export default CategoryAutocomplete;
